// extracted by mini-css-extract-plugin
export var aboveInput = "_mu-0";
export var actionButton = "_mu-5";
export var actionButtonContainer = "_mu-1";
export var actionIcon = "_mu-6";
export var aiInfoContainer = "_mu-2";
export var attachmentWrapper = "_mu-7";
export var bold = "_mu-3";
export var checkIcon = "_mu-8";
export var clickingRecipientBar = "_mu-11";
export var commentThreadSwitch = "_mu-a";
export var draftImage = "_mu-b";
export var draftImageContainer = "_mu-c";
export var draftImages = "_mu-e";
export var editButton = "_mu-g";
export var editor = "_mu-f";
export var editorContainer = "_mu-y";
export var editorErrorTooltipWrapper = "_mu-9";
export var headerDivider = "_mu-h";
export var icon = "_mu-i";
export var info = "_mu-j";
export var internal = "_mu-n";
export var internalDivider = "_mu-k";
export var internalMessage = "_mu-l";
export var messageInputCard = "_mu-m";
export var messageInputForm = "_mu-o";
export var messageInputFormInternal = "_mu-p";
export var options = "_mu-q";
export var publicMessageCustomer = "_mu-s";
export var publicMessageMerchant = "_mu-r";
export var removeImageButton = "_mu-d";
export var replyButtons = "_mu-t";
export var showSignatureButton = "_mu-u";
export var spinner = "_mu-v";
export var verticalButtonDivider = "_mu-4";
export var visibilitySelector = "_mu-w";
export var warning = "_mu-x";
export var wrappingText = "_mu-z";
export var writingInternalNoteTopBorder = "_mu-10";